<template>
  <div class="areaNav">
    <a href="javascript:;" @click.stop="navSwitch()" class="navSwitch" :class="{'active':areaNavOpen}"><i></i></a>
    <div class="areaNavMain" :class="{'active':areaNavOpen}">
      <div class="areaNavText fb">SELECT REGION</div>
      <div class="areaNavBox mt10">
        <router-link to="/asia" class="areaNavItem"><span>JS ASIA</span></router-link>
        <router-link to="/america" class="areaNavItem"><span>JS AMERICA</span></router-link>
        <router-link to="/europe" class="areaNavItem"><span>JS EUROPE</span></router-link>
        <router-link to="/middleEastAfrica" class="areaNavItem"><span>JS MIDDLE EAST & AFRICA</span></router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      areaNavOpen:false,

    }
  },


  methods:{
    navSwitch(){
      this.areaNavOpen = !this.areaNavOpen
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/areaNav.vue